/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useGetDocumentUploadLinks = makeQueryHook(
  operations.getDocumentUploadLinks,
)

export const useCreateDocumentUploadLink = makeMutationHook(
  operations.createDocumentUploadLink,
)

export const useGetDocumentUploadLink = makeQueryHook(
  operations.getDocumentUploadLink,
)

export const useListPersonDocuments = makeQueryHook(
  operations.listPersonDocuments,
)

export const useCreatePersonDocument = makeMutationHook(
  operations.createPersonDocument,
)

export const useListCompanyDocuments = makeQueryHook(
  operations.listCompanyDocuments,
)

export const useCreateCompanyDocument = makeMutationHook(
  operations.createCompanyDocument,
)

export const useGetPersonDocument = makeQueryHook(operations.getPersonDocument)

export const useUpdatePersonDocument = makeMutationHook(
  operations.updatePersonDocument,
)

export const useDeleteDocument = makeMutationHook(operations.deleteDocument)

export const useGetCompanyDocument = makeQueryHook(
  operations.getCompanyDocument,
)

export const useUpdateCompanyDocument = makeMutationHook(
  operations.updateCompanyDocument,
)

export const useDownloadPersonDocumentContent = makeQueryHook(
  operations.downloadPersonDocumentContent,
)

export const useUploadPersonDocumentContent = makeMutationHook(
  operations.uploadPersonDocumentContent,
)

export const useDownloadCompanyDocumentContent = makeQueryHook(
  operations.downloadCompanyDocumentContent,
)

export const useUploadCompanyDocumentContent = makeMutationHook(
  operations.uploadCompanyDocumentContent,
)

export const useConvertPersonDocument = makeMutationHook(
  operations.convertPersonDocument,
)

export const useConvertCompanyDocument = makeMutationHook(
  operations.convertCompanyDocument,
)

export const useReconvertCompanyDocument = makeMutationHook(
  operations.reconvertCompanyDocument,
)

export const useSignPersonPdfDocument = makeMutationHook(
  operations.signPersonPdfDocument,
)

export const useSignCompanyPdfDocument = makeMutationHook(
  operations.signCompanyPdfDocument,
)

export const useCreateDocumentViaLink = makeMutationHook(
  operations.createDocumentViaLink,
)

export const useUploadDocumentContentViaLink = makeMutationHook(
  operations.uploadDocumentContentViaLink,
)
